import {
  Flex,
  Select,
  Input,
  InputGroup,
  InputLeftAddon,
  SimpleGrid,
} from "@chakra-ui/react";

import React from "react";
import ApiService from "services/api.js";

export default function HeaderPBData(props) {
  // custom variable
  const {
    inputDateFrom,
    inputDateTo,
    inputBill,
    inputBranch,
    setDateFrom,
    setDateTo,
    setBill,
    setInputBranch,
    minDate,
    setMinDate,
    maxDate,
    setMaxDate
  } = props;

  const options = ApiService.optionsBranch()
  // Create a concatenated string of all branch IDs
  const allBranchValue = options?.map(data => data.id).join(',');

  // console.log("THES", allBranchValue)

  return (
    <Flex px="25px" justify="space-between" mb="20px" align="center">
      <SimpleGrid
        w="100%"
        mb="20px"
        columns={{ sm: 1, md: 2 }}
        spacing={{ base: "20px", xl: "20px" }}
      >
        <InputGroup>
          <InputLeftAddon children="Date From" />
          <Input
            focusBorderColor="black"
            placeholder="Select Date From"
            borderRadius="16px"
            type="date"
            value={inputDateFrom}
            onChange={(e) => setDateFrom(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Date To" />
          <Input
            focusBorderColor="black"
            placeholder="Select Date To"
            borderRadius="16px"
            type="date"
            min={minDate}
            max={maxDate}
            value={inputDateTo}
            onChange={(e) => setDateTo(e.target.value)}
          />
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Branch Name" />
          <Select
            value={inputBranch}
            onChange={(e) => setInputBranch(e.target.value)}
          >
            <option value={allBranchValue}>All Branch</option>
            {options?.map((data) => (
              <option key={data.id} value={data.id}>
                {data.name_branch}
              </option>
            ))}
          </Select>
          {/* <Input
            focusBorderColor="black"
            placeholder="Input Branch"
            borderRadius="16px"
            value={inputBranch}
            onChange={(e) => setInputBranch(e.target.value)}
          /> */}
        </InputGroup>
        <InputGroup>
          <InputLeftAddon children="Bill ID" />
          <Input
            focusBorderColor="black"
            placeholder="Input Bill ID"
            borderRadius="16px"
            value={inputBill}
            onChange={(e) => setBill(e.target.value)}
          />
        </InputGroup>
      </SimpleGrid>
    </Flex>
  );
}
